import React from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { BUSINESS, INSTAGRAM_GRID } from "@/lib/business";

export default function InstagramFeed() {
  const { t } = useI18n();

  // duplicate for marquee
  const items = [...INSTAGRAM_GRID, ...INSTAGRAM_GRID];

  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="relative py-16 md:py-20 bg-[#080808] border-y border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#e52620]" />
              <span
                data-testid="instagram-eyebrow"
                className="text-[11px] uppercase tracking-[0.3em] text-zinc-400 font-bold font-mono"
              >
                {t.instagram.eyebrow}
              </span>
            </div>
            <h2
              data-testid="instagram-title"
              className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-white leading-[0.95]"
            >
              {t.instagram.title}
            </h2>
            <p className="mt-4 text-zinc-400 max-w-xl">{t.instagram.subtitle}</p>
          </div>
          <a
            href={BUSINESS.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-cta"
            className="inline-flex items-center gap-3 bg-white text-black hover:bg-zinc-200 px-6 py-3 rounded-md font-bold uppercase tracking-[0.12em] text-xs transition-all active:scale-95 w-fit"
          >
            <Instagram className="w-4 h-4" />
            {t.instagram.cta}
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>

      {/* Marquee strip */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#080808] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#080808] to-transparent z-10 pointer-events-none" />
        <div className="flex gap-5 animate-marquee" style={{ width: "max-content" }}>
          {items.map((src, i) => (
            <a
              key={i}
              href={BUSINESS.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-tile-${i}`}
              className="relative block w-64 h-64 md:w-72 md:h-72 flex-shrink-0 rounded-xl overflow-hidden border border-white/10 hover:border-white/30 group"
            >
              <img
                src={src}
                alt="Instagram post"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-colors duration-300 flex items-center justify-center">
                <Instagram className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
